/* KZK Ön Talep — kişisel "Talebiniz Alındı" rozeti.
 * Giriş yapan müşterinin daha önce ön talep verdiği ürünlerde (koleksiyon kartı + ürün sayfası)
 * SADECE o müşteriye görünen bir ibare gösterir. Backend'den müşterinin talep verdiği
 * ürün handle listesi çekilir (GET /api/on-talep/my-requests). Metin/renk Tema Ayarları'ndan gelir.
 */
(function () {
  'use strict';

  var CFG = window.KZK_ONTALEP_BADGE || {};
  if (CFG.enabled === false) return;

  var API_BASE = window.KZK_API_BASE || 'https://senko.toserof.com';
  var TEXT = CFG.text || 'Talebiniz Alındı';
  var BG = CFG.bg || '#4f46e5';
  var COLOR = CFG.color || '#ffffff';
  var LABEL_TOP = (CFG.labelTop != null ? Number(CFG.labelTop) : 38); // kart etiketlerinin üst boşluğu (product-label.liquid ile aynı)

  var cust = window.customerData || {};
  var email = String(cust.email || '').trim().toLowerCase();
  if (!email) return; // misafir -> kişisel rozet yok

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  var CACHE_KEY = 'kzk_ontalep_handles_' + email;
  var CACHE_TTL = 5 * 60 * 1000; // 5 dk (talep sonrası submit'te ayrıca temizlenir)

  function getHandles(cb) {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        var obj = JSON.parse(raw);
        if (obj && obj.t && (Date.now() - obj.t) < CACHE_TTL && Array.isArray(obj.handles)) {
          cb(obj.handles); return;
        }
      }
    } catch (e) {}
    fetch(API_BASE + '/api/on-talep/my-requests?email=' + encodeURIComponent(email))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var handles = (j && j.ok && Array.isArray(j.handles)) ? j.handles : [];
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), handles: handles })); } catch (e) {}
        cb(handles);
      })
      .catch(function () { cb([]); });
  }

  function makeBadge() {
    var span = document.createElement('span');
    span.className = 'product-label product-label--ontalep inline-block kzk-ontalep-badge';
    span.textContent = TEXT;
    span.style.background = BG;
    span.style.color = COLOR;
    return span;
  }

  function makeWrapper() {
    var wrap = document.createElement('div');
    wrap.className = 'product-label-wrapper';
    wrap.appendChild(makeBadge());
    return wrap;
  }

  function cardHandle(card) {
    var trig = card.querySelector('.qv-trigger-btn[data-quickview-handle]');
    if (trig) return String(trig.getAttribute('data-quickview-handle') || '').toLowerCase();
    var link = card.querySelector('a[href*="/products/"]');
    if (link) {
      var m = String(link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m) return decodeURIComponent(m[1]).toLowerCase();
    }
    return '';
  }

  // Rozet, native etiket container'ına eklenir (Kutulu/Askılı/Tekleme ile aynı yerde,
  // kalbin altında stacklenir). Kartta hiç etiket yoksa container native ile aynı stille
  // oluşturulur; üst boşluk (kalbin altı) product-label.liquid ile aynı: LABEL_TOP.
  function ensureLabelContainer(card) {
    var c = card.querySelector('.product-label-container');
    if (!c) {
      c = document.createElement('div');
      c.className = 'product-label-container absolute start-0';
      c.style.top = LABEL_TOP + 'px';
      card.insertBefore(c, card.firstChild);
    }
    return c;
  }

  function decorateCards(set) {
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__kzkOntalepDone) continue;
      var h = cardHandle(card);
      if (h && set[h]) {
        var cont = ensureLabelContainer(card);
        if (!cont.querySelector('.kzk-ontalep-badge')) {
          cont.appendChild(makeWrapper());
        }
        card.__kzkOntalepDone = true;
      }
    }
  }

  function decorateProductPage(set) {
    var pd = window.productData;
    var handle = String(pd && pd.handle ? pd.handle : '').toLowerCase();
    if (!handle) {
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      handle = m ? decodeURIComponent(m[1]).toLowerCase() : '';
    }
    if (!handle || !set[handle]) return;
    if (document.querySelector('.kzk-ontalep-badge')) return; // zaten eklendi

    var wrap = document.createElement('div');
    wrap.className = 'product-label-container flex flex-wrap gap-x-2 gap-y-2';
    wrap.style.margin = '0 0 10px';
    wrap.appendChild(makeWrapper());

    // Öncelik: ön talep formunun hemen üstü; yoksa ürün başlığı bloğu
    var form = document.getElementById('kzk-ontalep');
    if (form && form.parentNode) {
      form.parentNode.insertBefore(wrap, form);
      return;
    }
    var title = document.querySelector('.product-info__block, .product-title, h1.h2, h1.h3, h1');
    if (title && title.parentNode) {
      title.parentNode.insertBefore(wrap, title.nextSibling);
    }
  }

  ready(function () {
    getHandles(function (handles) {
      if (!handles || !handles.length) return;
      var set = {};
      handles.forEach(function (h) { set[String(h).toLowerCase()] = true; });

      decorateCards(set);
      decorateProductPage(set);

      // Koleksiyonda AJAX filtre/sonsuz kaydırma ile yeni kartlar gelebilir
      if (window.MutationObserver) {
        var pending = false;
        var obs = new MutationObserver(function () {
          if (pending) return;
          pending = true;
          setTimeout(function () { pending = false; decorateCards(set); }, 200);
        });
        obs.observe(document.body, { childList: true, subtree: true });
      }
    });
  });
})();
